export enum CookieCategory {
	StrictlyNecessary = 'STRICTLY_NECESSARY',
	Functional = 'FUNCTIONAL',
	Marketing = 'MARKETING',
	Analytics = 'ANALYTICS',
	Unknown = 'UNKNOWN',
}

export enum ConsentPreference {
	ConsentDataUnavailable = 'CONSENT_DATA_UNAVAILABLE',
	ConsentedUnderGDPR = 'CONSENTS_SAVED_IN_GDPR_LOCALE',
	ConsentedUnderCPRA = 'CONSENTS_SAVED_IN_CPRA_LOCALE',
	ConsentedUnderLGPD = 'CONSENTS_SAVED_IN_LGPD_LOCALE',
	ConsentedUnderFADP = 'CONSENTS_SAVED_IN_FADP_LOCALE',
}

export type CookiePreferences = {
	[key in CookieCategory]: boolean;
};

export type AdditionalConsentPreferences = {
	[key in ConsentPreference]: boolean;
};

export type ConsentPreferences = CookiePreferences | AdditionalConsentPreferences;

type Keys = {
	[name: string]: number;
};

type Pattern = { [name: string]: Pattern | number };

export interface CategorizedCookiesCache {
	categories: {
		[CookieCategory.StrictlyNecessary]: number;
		[CookieCategory.Functional]: number;
		[CookieCategory.Analytics]: number;
		[CookieCategory.Marketing]: number;
		[CookieCategory.Unknown]: number;
	};
	keys: Keys;
	thirdPartyKeys: Keys;
	patterns: {
		startsWith: Pattern;
	};
	analyticsSamplingRatio?: {
		[name: string]: number;
	};
}

export interface CookiePreferenceV001 {
	[CookieCategory.StrictlyNecessary]: boolean;
	[CookieCategory.Functional]: boolean;
	[CookieCategory.Analytics]: boolean;
	[CookieCategory.Marketing]: boolean;
	[CookieCategory.Unknown]: boolean;
}

export interface CookiePreferenceV002 extends CookiePreferenceV001 {
	[ConsentPreference.ConsentDataUnavailable]: boolean;
	[ConsentPreference.ConsentedUnderGDPR]: boolean;
	[ConsentPreference.ConsentedUnderCPRA]: boolean;
	[ConsentPreference.ConsentedUnderLGPD]: boolean;
	[ConsentPreference.ConsentedUnderFADP]: boolean;
}

export type CookiePreference = CookiePreferenceV001 | CookiePreferenceV002;

export enum PrefetchedPreferenceState {
	INTERNAL,
}
